import React from "react";

const ConfirmationDialog = ({ isVisible, onConfirm, onCancel, message, textButtonConfirm = 'Salvar' }) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="w-[90%] max-w-[349px] p-6 bg-white rounded-md shadow-md border border-gray-200 flex flex-col items-center gap-4">
                <div className="text-stone-800 text-lg font-semibold text-center">
                    {message}
                </div>
                <div className="flex w-full justify-between gap-4">
                    <button
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md"
                        onClick={onCancel}
                    >
                        <img
                            className="w-4 h-4"
                            src="/images/icon/x-circle.png"
                            alt="Cancelar"
                        />
                        Cancelar
                    </button>
                    <button
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md"
                        onClick={onConfirm}
                    >
                        <img
                            className="w-4 h-4"
                            src="/images/icon/save.png"
                            alt="Salvar"
                        />
                        {textButtonConfirm}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDialog;
